import { DistributionHistory } from '@products/models/distribution-history';
import {
  CurrencyCode,
  DistributionHistoryDTO,
  FundId,
  ShareClassCode,
} from '@types';
import { MapperFactory } from './mapper-factory';
import { Mapper, MapperParams } from './type.mapper';

export class DistributionHistoriesMapper extends Mapper<DistributionHistory[]> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    distributionHistoriesDto: DistributionHistoryDTO[]
  ): DistributionHistory[] {
    const distributionHistories: DistributionHistory[] = [];

    distributionHistoriesDto.forEach(
      (distributionHistoryDto: DistributionHistoryDTO) => {
        const distributionHistory: DistributionHistory = this.createMapper(
          DistributionHistoryMapper
        ).toDomain(distributionHistoryDto);

        if (distributionHistory) {
          distributionHistories.push(distributionHistory);
        }
      }
    );

    return distributionHistories;
  }
}

export class DistributionHistoryMapper extends Mapper<DistributionHistory> {
  constructor(mapperParams: MapperParams, mapperFactory: MapperFactory) {
    super(mapperParams, mapperFactory);
  }

  toDomain(
    distributionHistoryDto: DistributionHistoryDTO
  ): DistributionHistory {
    return {
      fundId: distributionHistoryDto.fundid as FundId,
      shareClassCode: distributionHistoryDto.shclcode as ShareClassCode,
      shareClassFeeStructure: distributionHistoryDto.shclfeestructr,
      shareClassCurrency: distributionHistoryDto.shclcurr,
      investmentCategory: distributionHistoryDto.invstmntcategory,
      currencyCode: distributionHistoryDto.currcode as CurrencyCode,
      distributionAsOfDate: distributionHistoryDto.asofdate,
      distributionAsOfDateStd: distributionHistoryDto.asofdatestd,
      distributionAsOfDateYear: distributionHistoryDto.asofdatestd
        ? distributionHistoryDto.asofdatestd.split('-')[0]
        : null, // exclusively added and mapped as per asOfDateStd.
      incomeDistributionExDividendDate:
        distributionHistoryDto.incmdistexdivdate,
      incomeDistributionExPayableDate:
        distributionHistoryDto.incmdistexpayabledate,
      incomeDistributionRecordDate: distributionHistoryDto.incmdistrecorddate,
      capitalGainPayableDate: distributionHistoryDto.capgainpayabledate,
      capitalGainRecordDate: distributionHistoryDto.capgainrecorddate,
      capitalGainExDividendDate: distributionHistoryDto.capgainexdivdate,
      capitalGainReInvestmentDate:
        distributionHistoryDto.capgainreinvestmentdate,
      reInvestmentDate: distributionHistoryDto.reinvstmntdate,
      incomeDistributionAmount: distributionHistoryDto.incmdistamt,
      longTermCapitalGain: distributionHistoryDto.capgainamtlongterm,
      shortTermCapitalGain: distributionHistoryDto.capgainamtshortterm,
      reInvestmentAmount: distributionHistoryDto.reinvstmntamt,
      exDividendNavValue: distributionHistoryDto.exdivnavval,
      recordDateNavVal: distributionHistoryDto.recdtnavval,
      returnOfCapitalAmount: distributionHistoryDto.returnofcapitalamt,
      totalDistributionAmountMonthly: distributionHistoryDto.totaldistamtmth,
      totalDistributionAmountDaily: distributionHistoryDto.totaldistamtdaily,
      distributionCount: distributionHistoryDto.distribcnt,
      taxExemptIncomeAmount: distributionHistoryDto.taxexemptincmamt,
      longTermCapitalGainYtd: distributionHistoryDto.longtermcapgainsytd,
      shortTermCapitalGainYtd: distributionHistoryDto.shorttermcapgainsytd,
      incomeDistributionAmountYtd: distributionHistoryDto.incmdistamtytd,
      capitalGainReInvestmentAmount:
        distributionHistoryDto.capgainreinvstmntamt,
      capitalGainFrequency: distributionHistoryDto.capgainfreq,
      shareClassDistributionCode: distributionHistoryDto.shcldistribcode,
      divDistributionIncome: distributionHistoryDto.divpaidoutnetdistincm,
      dividendCapital: distributionHistoryDto.divpaidoutcapital,
    };
  }
}
